/**
 * TanStack Query hooks for `email-notification-templates`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	emailNotificationTemplatesQueryKeys,
	type CreateEmailNotificationTemplatesBody,
	type ListEmailNotificationTemplatesResponse,
	type EmailNotificationTemplatesRow,
} from "./api";

export function useEmailNotificationTemplatesList(): UseQueryResult<ListEmailNotificationTemplatesResponse, Error> {
	return useQuery({
		queryKey: emailNotificationTemplatesQueryKeys.list(),
		queryFn: list,
	});
}

export function useEmailNotificationTemplatesCreate(): UseMutationResult<EmailNotificationTemplatesRow, Error, CreateEmailNotificationTemplatesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emailNotificationTemplatesQueryKeys.all });
		},
	});
}

export function useEmailNotificationTemplatesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emailNotificationTemplatesQueryKeys.all });
		},
	});
}
